import { createContext, useContext } from 'react';

export const CurrencyContext = createContext<string | undefined>('');

export const CurrencyProvider = CurrencyContext.Provider;

export const useCurrency = () => {
  return useContext(CurrencyContext);
};
